import { render, staticRenderFns } from "./CallModalEdit.vue?vue&type=template&id=fef8854c&scoped=true&"
import script from "./CallModalEdit.vue?vue&type=script&lang=js&"
export * from "./CallModalEdit.vue?vue&type=script&lang=js&"
import style0 from "./CallModalEdit.vue?vue&type=style&index=0&id=fef8854c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef8854c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VBtn,VIcon,VRadio,VRadioGroup,VSelect,VTextarea})
